import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    marginTop: 10,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: theme.spacing(2, 0),
    "@media(max-width:768px)": {
      flexDirection: "column",
    },
  },
  text: {
    fontSize: ".75rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
  gif: {
    maxWidth: "450px",
    "@media(max-width:1200px)": {
      maxWidth: "400px",
    },
    "@media(max-width:1000px)": {
      maxWidth: "300px",
    },
  },
}));

export default useStyles;
